import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ScfHoldPointDashboardRow } from './scf-hold-point-dashboard.models';

@Injectable({ providedIn: 'root' })
export class ScfHoldPointDashboardService {
  private readonly api = `${environment.urls.baseApiUrl}/SCFMasterV2/HoldPointDashboard`;
  private selectedSerialNo: string | null = null;

  constructor(private readonly http: HttpClient) { }

  /** Loads open SCFs and their persisted hold-point signature progress. */
  getDashboard(): Observable<ScfHoldPointDashboardRow[]> {
    return this.http.get<ScfHoldPointDashboardRow[]>(this.api);
  }

  /**
   * Stores the SCF selection for the next Hold Points page navigation.
   * @param serialNo Serial number to highlight, or null when no SCF is selected.
   */
  setSelectedSerialNo(serialNo: string | null | undefined): void {
    this.selectedSerialNo = serialNo || null;
  }

  /**
   * Returns and clears the SCF selection passed from the SCF page.
   * @returns The selected serial number, if one was provided.
   */
  consumeSelectedSerialNo(): string | null {
    const serialNo = this.selectedSerialNo;
    this.selectedSerialNo = null;
    return serialNo;
  }
}
